

export function externalRoute( url : string ) {
	window.location.href = url;
}
